import React, { useState } from 'react'
import {
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  Button,
  Box,
  Tooltip,
  CircularProgress,
} from '@material-ui/core'
import { CloudDownload } from '@material-ui/icons'

const DownloadFastqButton = ({ onClickConfirm, sampleName, downloadingFastqId, fastqPairId }) => {
  const [dialogOpen, setDialogOpen] = useState(false)

  const handleClickDownload = () => {
    setDialogOpen(true)
  }

  const handleCloseDialog = () => {
    setDialogOpen(false)
  }

  const handleClickConfirm = () => {
    setDialogOpen(false)
    onClickConfirm()
  }

  return (
    <>
      <Tooltip title="Download FASTQ pair">
        <IconButton onClick={handleClickDownload} disabled={downloadingFastqId === fastqPairId}>
          {downloadingFastqId === fastqPairId ? <CircularProgress size={24} /> : <CloudDownload />}
        </IconButton>
      </Tooltip>
      <Dialog open={dialogOpen} onClose={handleCloseDialog}>
        <DialogTitle>Download FASTQ Files</DialogTitle>
        <Box p={0.5} />
        <DialogContent>
          <DialogContentText>
            You are about to download the FASTQ pair for sample: <strong>{sampleName}</strong>
          </DialogContentText>
          <DialogContentText>This will download both files in a compressed (ZIP) format.</DialogContentText>
          <DialogContentText>Please ensure you have enough disk space as FASTQ files can be large.</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button onClick={handleClickConfirm} autoFocus color="primary" variant="contained">
            Download
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default DownloadFastqButton
